import { render, staticRenderFns } from "./StandartsCatalogGroup.vue?vue&type=template&id=2c0039a6&"
import script from "./StandartsCatalogGroup.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports